<mibi-box-layout>

<div class="mibi-nav-bar">
    <div class="mibi-nav-bar__left">
        <ng-content select="[mibi-nav-bar-title]"></ng-content>
    </div>
    <div class="mibi-nav-bar__center">
        <ng-content select="[mibi-nav-bar-tabs]"></ng-content>
    </div>
    <div class="mibi-nav-bar__right">
        <ng-content select="[mibi-nav-bar-user]"></ng-content>
    </div>
</div>

</mibi-box-layout>